<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="搜索用户UID"
                clearable
                v-model="id"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="搜索订单ID"
                clearable
                v-model="id"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="搜索合约名"
                clearable
                v-model="id"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对ID"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value2"
                type="daterange"
                align="right"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                clearable
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="900">
        <el-table-column label="头像" prop="symbol" />
        <el-table-column label="跟单员名称" prop="takerFee" />
        <el-table-column label="用户UID" prop="takerFee" />
        <el-table-column label="累计跟随本金(USDT)" prop="takerFee" />
        <el-table-column label="总胜率" prop="takerFee" />
        <el-table-column label="总权益(USDT)" prop="takerFee" />
        <el-table-column label="盈利笔数/跟单笔数" prop="takerFee" />
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作员" prop="symbol" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showTabBox(scope.row)"
              >成交明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>

      <el-dialog
        :title="tabModaltitle"
        :visible="dialogVisible1"
        width="800px"
        @close="closeTabBox"
        :destroy-on-close="true"
      >
        <div class="modalSearch">
          <el-input placeholder="搜索UID" clearable v-model="id" size="mini">
          </el-input>
          <el-input
            placeholder="搜索交易员名称"
            clearable
            v-model="id"
            size="mini"
          >
          </el-input>
          <el-select
            v-model="symbolId"
            placeholder="状态"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in statusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            size="mini"
            type="primary"
            @click="getModalData({ page: 1 })"
            >查询</el-button
          >
        </div>
        <el-table :data="modalTabList">
          <el-table-column label="交易员" prop="symbol" />
          <el-table-column label="用户UID" prop="takerFee" />
          <el-table-column label="用户UID" prop="takerFee" />
          <el-table-column prop="" label="状态">
            <template slot-scope="scope"> </template>
          </el-table-column>
          <el-table-column prop="" label="盈利笔数/跟单笔数" />
          <el-table-column label="累计跟单本金" prop="takerFee" />
          <el-table-column label="跟单总交易额" prop="takerFee" />
          <el-table-column label="跟单总盈亏" prop="takerFee" />
          <el-table-column label="更新时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.createdTime | moment }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :size="modalPagination.size"
          :total="modalTotalCount"
          :page="modalPagination.page"
          @pageChanged="modalPaginationHandle"
        >
        </pagination>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      id: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      timeRange: "",
      symbolId: "",
      symbolList: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      modalTabList: [],
      modalTotalCount: 0,
      modalPagination: {
        page: 1,
        size: 25,
      },
      dialogVisible1: false,
      tabModaltitle: "xx的列表",
      statusArr: [
        { label: "全部", value: "" },
        { label: "跟单中", value: "1" },
        { label: "已取消", value: "2" },
      ],
      activeTab: "aa",
    };
  },
  computed: {},
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .getSpotSymbolPage({
          id: this.id,
          symbolId: this.symbolId,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },

    showTabBox(type) {
      this.dialogVisible1 = true;
      // this.tabModaltitle=''
      this.getModalData();
    },
    getModalData(data = {}) {
      this.handleSearch();
    },
    closeTabBox() {
      this.dialogVisible1 = false;
      this.tabModaltitle = "";
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
    },
    modalPaginationHandle(pagination) {
      this.modalPagination = pagination;
      this.getModalData();
    },
    handleTabChange(tab) {
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
      this.getCopyModalTabData();
    },
    getCopyModalTabData() {
      console.log("2222", 2222);
      // ...modalPagination
      // startTime: this.timeRange ? this.timeRange[0] : "",
      // endTime: this.timeRange ? this.timeRange[1] : "",
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.modalSearch {
  display: flex;
  gap: 20px;
  .el-input {
    width: 200px;
  }
}
</style>
